import { useRouter } from 'next/router';

import { FiltersV2 } from '../../../../../features/filters/FiltersV2';
import { useFilterProps } from '../../../../../components/SearchPage/features/QuickFilters/FilterProps.hook';
import { useQuickFilterContext } from '../../../../../components/SearchPage/features/QuickFilters/QuickFilters.context';

import type { GroupedQuickFilterProps } from './GroupedQuickFilter.typed';
import * as Styled from './GroupedQuickFilter.styled';

const GroupedQuickFilter = (props: GroupedQuickFilterProps) => {
  const {
    subfilter,
    sectionName,
    locationConfiguration,
    makeModelConfiguration,
    validPriceConfiguration,
    gap,
  } = props;

  const { query } = useRouter();

  const { onChangeFilterValue, selectedFilterQueryParam } =
    useQuickFilterContext();

  const { getFilterProps } = useFilterProps({
    onChangeFilterValue,
    filterQueryValues: { ...query, ...selectedFilterQueryParam },
  });

  const { onChange, value } = getFilterProps(
    subfilter?.filterType.name ?? '',
    subfilter.name,
    subfilter.searchQueryGroup,
  );

  return (
    <Styled.Wrapper gap={gap}>
      <FiltersV2
        filter={{
          ...subfilter,
          showMoreLabel: subfilter.displayName,
          displayName: subfilter.hideDisplayName ? '' : subfilter.displayName,
          onChange,
          value,
        }}
        locationConfiguration={locationConfiguration}
        makeModelConfiguration={makeModelConfiguration}
        validPriceConfiguration={validPriceConfiguration}
        sectionName={sectionName}
      />
    </Styled.Wrapper>
  );
};

export { GroupedQuickFilter };
